<template>
  <v-row class="ml-1 mr-1">
    <!-- Tipo texto -->
    <v-menu
        v-if="filter && filter.type==='text'"
        offset-y
        :close-on-content-click="false"
        v-model="textMenu"
        >
      <template v-slot:activator="{ on }">
        <v-chip v-on="on" close @click:close="$emit('remove-filter')">
          <v-icon left>{{ filter.icon }}</v-icon>
          {{ filter.label }}{{ filter.value ? ": " + filter.value : "" }}
        </v-chip>
      </template>

      <div class="menu-background">
        <div style="max-height: 300px; overflow-y: auto;">
          <v-text-field
              :label="$t('AppSearchFilterChip.value')+'...'"
              v-model="text_input"
              @change="updateValueText(filter.name,text_input)"
              solo
              clearable
          ></v-text-field>
        </div>
      </div>
    </v-menu>
    <!-- Tipo date -->
    <app-date-picker
      v-else-if="this.filter && this.filter.type==='date'"
      aucomplete="off"
      :is-chip="true"
      :label="filter.label"
      :value="filter.value"
      @input="updateDate"
      @remove-filter="$emit('remove-filter')"
    />
    <!-- Tipo number -->
    <v-menu
        v-else-if="this.filter && this.filter.type==='number'"
        offset-y
        :close-on-content-click="false"
        v-model="textMenu"
        >
      <template v-slot:activator="{ on }">
        <v-chip v-on="on" close @click:close="$emit('remove-filter')">
          <v-icon left>{{ filter.icon }}</v-icon>
          {{ filter.label }}{{ filter.value ? ": " + filter.value : "" }}
        </v-chip>
      </template>

      <div class="menu-background">
        <div style="max-height: 300px; overflow-y: auto;">
          <v-text-field
              label="Valor..."
              v-model="text_input"
              type="number"
              @change="updateValueText(filter.name,text_input)"
              solo
              clearable
          ></v-text-field>
        </div>
      </div>
    </v-menu>
    <!-- Tipo select (simple) -->
    <v-menu
        v-else-if="this.filter && this.filter.type==='select' && !this.filter.multiple"
        offset-y
        bottom right
        v-model="selectMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-bind="attrs" v-on="on" closeable close @click:close="$emit('remove-filter')">
          <template v-if="filter && filter.value">
            {{ filter.label }} {{ filter.value
              ? formattedToChangeLanguage(filter.text)
                ? ": " + $t('AppSearchFilterChip.'+formattedToChangeLanguage(filter.text))
                  : ": " + filter.text
              : ""
            }}
          </template>
          <template v-else>
            {{ filter.label }}
          </template>
        </v-chip>
      </template>
      <div style="max-height: 300px; overflow-y: auto;">
        <v-list dense>
          <!-- Mensaje cuando no hay opciones disponibles -->
          <v-list-item v-if="!hasSelectOptions">
            <v-list-item-content>
              <v-list-item-title class="text--secondary text-caption">
                {{ $t('AppSearchFilterChip.no_options_available') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item-group v-else>
            <v-list-item
                v-for="(f, index) in filter.user_values ? filter.user_values : filter.values"
                :key="index"
                @click="updateValue(f,filter)"
            >
              <v-list-item-title>
                {{ formattedToChangeLanguage(f.text)? $t('AppSearchFilterChip.'+formattedToChangeLanguage(f.text)): f.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </v-menu>
    <!-- Tipo select (multiple) -->
    <v-menu
        v-else-if="this.filter && this.filter.type==='select' && this.filter.multiple"
        offset-y
        bottom right
        :close-on-content-click="false"
        v-model="multiSelectMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-bind="attrs" v-on="on" closeable close @click:close="$emit('remove-filter')">
          <template v-if="filter && filter.value && selectedMultiValues.length > 0">
            {{ filter.label }}: {{ selectedMultiValuesText }}
          </template>
          <template v-else>
            {{ filter.label }}
          </template>
        </v-chip>
      </template>
      <div class="menu-background pa-2" style="max-height: 400px; overflow-y: auto;">
        <v-list dense>
          <!-- Mensaje cuando no hay opciones disponibles -->
          <v-list-item v-if="!hasSelectOptions">
            <v-list-item-content>
              <v-list-item-title class="text--secondary text-caption">
                {{ $t('AppSearchFilterChip.no_options_available') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <template v-else>
            <v-list-item
                v-for="(f, index) in filter.user_values ? filter.user_values : filter.values"
                :key="index"
                @click="toggleMultiValue(f)"
            >
              <v-list-item-action>
                <v-checkbox
                    :input-value="isValueSelected(f.value)"
                    color="primary"
                    @click.stop="toggleMultiValue(f)"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ formattedToChangeLanguage(f.text)? $t('AppSearchFilterChip.'+formattedToChangeLanguage(f.text)): f.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-divider v-if="hasSelectOptions" class="my-2"></v-divider>
        <v-row v-if="hasSelectOptions" class="px-2" no-gutters>
          <v-btn small text @click="clearMultiSelection" class="mr-2">
            Limpiar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="applyMultiSelection">
            Aplicar
          </v-btn>
        </v-row>
      </div>
    </v-menu>
  </v-row>
</template>

<script>

import AppDatePicker from "@/components/layout/AppDatePicker.vue";

export default {
  name: "AppSearchFilterChip",
  components: {
    AppDatePicker
  },
  props: {
    filter: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data() {
    return {
      selectMenu: false,
      multiSelectMenu: false,
      textMenu: false,
      text_input:'',
      date_text: undefined,
      selectedMultiValues: [], // Array of {value, text} objects
    };
  },
  methods: {
    
    updateValue(e,f) {
      if (this.filter.hasOwnProperty('initial') && this.filter.initial) {
          this.filter.value = e.value;
          this.filter.text = e.text;
      }
      this.$emit('updateObject',{key:f.name,value:e.value,text:e.text})
      this.selectMenu = false;
    },
    updateValueText(name,text) {
      this.$emit('updateObject',{key:name,value:text,text:text})
      this.selectMenu = false;
    },
    updateDate(text) {
      this.$emit('updateObject',{key:this.filter.name,value:text,text:text})
      this.selectMenu = false;
    },

    // Multi-select methods
    toggleMultiValue(item) {
      const index = this.selectedMultiValues.findIndex(v => v.value === item.value);
      if (index > -1) {
        // Ya está seleccionado, quitarlo
        this.selectedMultiValues.splice(index, 1);
      } else {
        // No está seleccionado, agregarlo
        this.selectedMultiValues.push({ value: item.value, text: item.text });
      }
    },

    isValueSelected(value) {
      return this.selectedMultiValues.some(v => v.value === value);
    },

    clearMultiSelection() {
      this.selectedMultiValues = [];
    },

    applyMultiSelection() {
      // Convertir array a string separado por comas
      const valueString = this.selectedMultiValues.map(v => v.value).join(',');
      const textString = this.selectedMultiValues.map(v => v.text).join(', ');

      this.$emit('updateObject', {
        key: this.filter.name,
        value: valueString,
        text: textString
      });

      this.multiSelectMenu = false;
    },

    formattedToChangeLanguage(text){
      switch(text){
        case "Nómina":
          return "payroll"
        case "Contrato":
          return "contract"
        case "Modelos/Impuestos":
          return "taxes_and_models"
        case "Certificado":
          return "certificate"
        case "Facturas":
          return "invoices"
        case "Otros":
          return "others"
        case "Todos":
          return "all"
        case "Sí":
          return "yes"
        case "No":
          return "no"
        default:
          return ""
      }
    }
  },
  computed: {
    // Verifica si hay opciones disponibles para el select
    hasSelectOptions() {
      const options = this.filter.user_values || this.filter.values;
      return options && Array.isArray(options) && options.length > 0;
    },
    selectedMultiValuesText() {
      if (this.selectedMultiValues.length === 0) {
        return '';
      }
      if (this.selectedMultiValues.length <= 3) {
        // Mostrar hasta 3 valores
        return this.selectedMultiValues.map(v => v.text).join(', ');
      } else {
        // Mostrar contador si hay más de 3
        return `${this.selectedMultiValues.length} seleccionados`;
      }
    }
  },
  mounted() {
    // Inicializar valores múltiples si existen
    if (this.filter.multiple && this.filter.value) {
      const values = this.filter.value.split(',');
      const texts = this.filter.text ? this.filter.text.split(', ') : values;

      this.selectedMultiValues = values.map((value, index) => ({
        value: value.trim(),
        text: texts[index] ? texts[index].trim() : value.trim()
      }));
    }
  },
};
</script>
<style scoped>
.menu-background {
  background-color: white;
}
</style>